module.exports = __webpack_public_path__ + "static/og-image-511e21582922d401b7250e6a9edf4ac1.jpg";